import { Solver } from "@decisionrules/decisionrules-js/dist";

const apiKey: string | undefined =
  process.env.REACT_APP_DECISION_RULES_SOLVER_API_KEY;
const solver = new Solver(apiKey ?? "");

export const DRRuleResolver = async (ruleId: string, payload: any) => {
  try {
    let response = await solver.solveRule(ruleId, payload, 1);
    return response;
  } catch (Err: any) {
    throw Error("DR POST was not successful: ", Err);
  }
};

export const DRFlowResolver = async (ruleId: string, payload: any) => {
  try {
    let response = await solver.solveRuleFlow(ruleId, payload, 1);
    return response;
  } catch (Err: any) {
    throw Error("DR POST was not successful: ", Err);
  }
};
